export default __webpack_public_path__ + "static/media/bg_play.5d1506f0.jpg";